const fallbackLanguage = "en-US";
const projectToken = import.meta.env.VITE_SIMPLELOCALIZE_PROJECT_TOKEN; // SimpleLocalize Project Token

const loadPath = `https://cdn.simplelocalize.io/${projectToken}/_latest/{{lng}}`;

export { fallbackLanguage, projectToken, loadPath };
